import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AccessibilityService } from 'src/app/services/accessibility.service';
import { Language, LanguageService } from 'src/app/services/language-service.service';
import { PopupMenuComponent } from 'src/app/subcomponents/popup-menu/popup-menu.component';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit, OnDestroy {


  @ViewChild('optionsPopup', {read: PopupMenuComponent, static: true}) optionsPopup: PopupMenuComponent;

  private languageShifter = 0;

  public startGameText = 'start_game';

  public keyboardSubscriber: Subscription;

  public keyboardControlOn = false;
  public colorblindModeOn = false;
  public contrastModeOn = false;
  public noStressOn = false;
  public optionsOpen = false;

  constructor(private accessibilityHandler: AccessibilityService,
              private router: Router,
              public languageService: LanguageService) { }

  ngOnInit(): void {
    this.languageService.CheckRelevantCookieData();
    this.accessibilityHandler.CheckRelevantCookieData();

    this.keyboardControlOn = this.accessibilityHandler.keyboardAccessibilityOn;
    this.colorblindModeOn = this.accessibilityHandler.colorBlindAccessibilityOn;
    this.contrastModeOn = this.accessibilityHandler.highContrastAccessibilityOn;
    this.noStressOn = this.accessibilityHandler.stressFreeAccessibilityOn;

    switch (this.languageService.uiLanguage) {
      case Language.FIN: {
        this.languageShifter = 0;
        break;
      }
      case Language.SWE: {
        this.languageShifter = 1;
        break;
      }
      case Language.ENG: {
        this.languageShifter = 2;
        break;
      }
      default: {
        this.languageShifter = 0;
        this.languageService.uiLanguage = Language.FIN;
        this.languageService.SaveCurrentValues();
      }
    }

    this.keyboardSubscriber = this.accessibilityHandler.keyEventObs.subscribe(buttonPress => {

      if (buttonPress.key === ' ') {
        if (this.optionsOpen) {
          this.changeAccessibility('keyboard');
          return;
        }
        else {
          this.optionsOpen = true;
          this.optionsPopup.openPopupMenu();
          return;
        }
      }

      if (!this.accessibilityHandler.keyboardAccessibilityOn) {
        return;
      }

      if (buttonPress.key === 'Enter') {
        if (this.optionsOpen) {
          this.optionsOpen = false;
          this.optionsPopup.closePopupMenu();
        }
        else {
          this.keyboardSubscriber.unsubscribe();
          this.router.navigate(['/start-game']);
        }
      }

      if (buttonPress.key === 'l' || buttonPress.key === 'L') {
        this.ChooseLanguage();
      }

      if (buttonPress.key === 'b' || buttonPress.key === 'B') {
        this.changeAccessibility('color');
      }

      if (buttonPress.key === 'h' || buttonPress.key === 'H') {
        this.changeAccessibility('contrast');
      }

      if (buttonPress.key === 't' || buttonPress.key === 'T') {
        this.changeAccessibility('stress');
      }

    });

  }

  ngOnDestroy(): void {
    this.keyboardSubscriber.unsubscribe();
  }

  public ChooseLanguage(): void {

    this.languageShifter = (this.languageShifter + 1) % 3;

    switch (this.languageShifter) {
      case 0: {
        this.languageService.uiLanguage = Language.FIN;
        break;
      }
      case 1: {
        this.languageService.uiLanguage = Language.SWE;
        break;
      }
      case 2: {
        this.languageService.uiLanguage = Language.ENG;
        break;
      }
    }

    this.languageService.SaveCurrentValues();

  }

  public changeAccessibility(choice: string): void {
    if (choice === 'keyboard') {
      this.accessibilityHandler.keyboardAccessibilityOn = !this.accessibilityHandler.keyboardAccessibilityOn;
      this.keyboardControlOn = this.accessibilityHandler.keyboardAccessibilityOn;
    }
    if (choice === 'color') {
      this.accessibilityHandler.colorBlindAccessibilityOn = !this.accessibilityHandler.colorBlindAccessibilityOn;
      this.colorblindModeOn = this.accessibilityHandler.colorBlindAccessibilityOn;
    }
    if (choice === 'contrast') {
      this.accessibilityHandler.highContrastAccessibilityOn = !this.accessibilityHandler.highContrastAccessibilityOn;
      this.contrastModeOn = this.accessibilityHandler.highContrastAccessibilityOn;
    }
    if (choice === 'stress') {
      this.accessibilityHandler.stressFreeAccessibilityOn = !this.accessibilityHandler.stressFreeAccessibilityOn;
      this.noStressOn = this.accessibilityHandler.stressFreeAccessibilityOn;
    }

    this.accessibilityHandler.SaveCurrentValues();
  }


}
